import type { ReactNode } from 'react';

import { Sidebar } from './Sidebar';

interface AuthenticatedShellProps {
  children: ReactNode;
}

export const AuthenticatedShell = ({ children }: AuthenticatedShellProps) => (
  <div className="flex h-viewport overflow-hidden">
    <Sidebar />
    <div className="flex-1 flex flex-col min-w-0 overflow-hidden">{children}</div>
  </div>
);
